<div class="row nopadding">
  <div class="panel-heading nopadding">
      <p>
          <button type="button"  (click)="reloadData('Total')" class="btn btn-primary  btn-xs defaultBtnColor">Total</button>
          <button type="button"  (click)="reloadData('Front Running')"  class="btn btn-primary btn-xs defaultBtnColor">Front Running</button>
          <button type="button"  (click)="reloadData('Market Abuse')"  class="btn btn-primary btn-xs defaultBtnColor">Market Abuse</button>
          <button type="button" (click)="reloadData('Cat')"  class="btn btn-primary btn-xs defaultBtnColor">CAT</button>
          <button type="button" (click)="reloadData('Client Data')"  class="btn btn-primary btn-xs defaultBtnColor">Client Data</button>
          <button type="button" (click)="reloadData('CAIS')"  class="btn btn-primary btn-xs defaultBtnColor">CAIS</button>
      </p>
    </div>
</div>
<div class="carousel carousel-showmanymoveone slide" id="carousel-tilenav" data-interval="false">

<div class="carousel-inner">
  <div class="panel panel-default nopadding">
    <div class="panel-heading  ">
      <p class=" panel-title">Exception Count</p>
    </div>
    <div class="panel-body nopadding">

      <canvas
        baseChart
        class="chart"
        [data]="barChartData"
        [type]="'bar'"
        [options]="barChartOptions" 
        (chartHover)="chartHovered($event)" 
        (chartClick)="chartClicked($event)">
      </canvas>
    </div>
  </div>
</div>

<a class="align-bottom left carousel-control" matTooltip="Prev" (click)="clickLeft()" data-slide="prev">
  <i class="glyphicon glyphicon-chevron-left"></i>
</a>
<a class="align-bottom right carousel-control"  matTooltip="Next" (click)="clickRight()" data-slide="next">
  <i class="glyphicon glyphicon-chevron-right"></i>
</a>

</div>